import { useState } from 'react';

export const useMenuModal = () => {
  const [showMenuModal, setShowMenuModal] = useState(false);
  const [currentMenuItem, setCurrentMenuItem] = useState(null);
  const [currentMenuItems, setCurrentMenuItems] = useState([]);
  const [currentMenuIndex, setCurrentMenuIndex] = useState(0);

  const openMenuModal = (menuItem, menuItems, index) => {
    setCurrentMenuItem(menuItem);
    setCurrentMenuItems(menuItems);
    setCurrentMenuIndex(index);
    setShowMenuModal(true);
    // Prevent body scroll when modal is open - Enhanced mobile prevention
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    document.documentElement.style.overflow = 'hidden';
  };

  const closeMenuModal = () => {
    setShowMenuModal(false);
    setCurrentMenuItem(null);
    setCurrentMenuItems([]);
    setCurrentMenuIndex(0);
    // Restore body scroll
    document.body.style.overflow = 'unset';
    document.body.style.position = 'static';
    document.body.style.width = 'auto';
    document.body.style.height = 'auto';
    document.documentElement.style.overflow = 'unset';
  };

  const setMenuIndex = (indexOrCallback) => {
    setCurrentMenuIndex((prevIndex) => {
      const newIndex = typeof indexOrCallback === 'function' ? indexOrCallback(prevIndex) : indexOrCallback;
      if (currentMenuItems && currentMenuItems[newIndex]) {
        setCurrentMenuItem(currentMenuItems[newIndex]);
        return newIndex;
      }
      return prevIndex;
    });
  };

  return {
    showMenuModal,
    currentMenuItem,
    currentMenuItems,
    currentMenuIndex,
    openMenuModal,
    closeMenuModal,
    setMenuIndex
  };
};